import { createDestinationLanding } from '@/router/destinationRoute';
import { useCompanyBankFeedAccess } from '@/abilities/companyBankFeed/useCompanyBankFeedAccess';
import { companyBankFeedDestinationTree } from '@/abilities/companyBankFeed/vocabulary';
import { companyBankFeedDestinationRoutes } from '@/pages/company/BankFeedRoute/destinationRoutes';

export const { landingPath: companyBankFeedLandingPath, landing: companyBankFeedLanding } = createDestinationLanding(
  companyBankFeedDestinationTree,
  companyBankFeedDestinationRoutes,
  useCompanyBankFeedAccess,
);
